<template>
  <SettingsPagePanelHeader>
    <template v-slot:title>{{ title }}</template>
    <template v-slot:right>
      <div :class="[$style.header__buttons, $style.buttons]">
        <template v-if="isEditing">
          <FlatButton
            variant="secondary"
            size="medium"
            @click="emit('cancelButtonClick')"
          >
            キャンセル
          </FlatButton>
          <FlatButton
            variant="primary"
            size="medium"
            @click="emit('buttonClick')"
            :disabled="isButtonDisabled"
          >
            保存
          </FlatButton>
        </template>
        <template v-else>
          <FlatAnchorLinkButton
            variant="secondary"
            size="medium"
            :href="selfPageHref"
            target="_blank"
            rel="noopener"
          >
            <template #icon>
              <IconEyeOn />
            </template>
            公開情報を確認
          </FlatAnchorLinkButton>
          <FlatButton
            variant="primary"
            size="medium"
            @click="emit('buttonClick')"
            :disabled="isButtonDisabled"
          >
            <template #icon>
              <IconPen />
            </template>
            編集
          </FlatButton>
        </template>
      </div>
    </template>
  </SettingsPagePanelHeader>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import IconEyeOn from '@/components/icons/IconEyeOn.vue'
import IconPen from '@/components/icons/IconPen.vue'
import SettingsPagePanelHeader from '../SettingsPagePanelHeader.vue'
import type { Planner } from '@/types/app'
import { getShadowPlannerDetailURL } from '@/config'
import FlatButton from '@/components/atoms/FlatButton.vue'
import FlatAnchorLinkButton from '@/components/atoms/FlatAnchorLinkButton.vue'

const props = defineProps<{
  planner: Planner
  isEditing: boolean
  isButtonDisabled: boolean
}>()

const emit = defineEmits<{
  (event: 'buttonClick'): void
  (event: 'cancelButtonClick'): void
}>()

const selfPageHref = computed((): Maybe<string> =>
  props.isEditing ? undefined : getShadowPlannerDetailURL(props.planner.id)
)

const title = computed(() =>
  props.isEditing ? 'プロフィール - 編集' : 'プロフィール'
)
</script>

<style lang="scss" module>
.header {
  display: flex;
  align-items: center;

  &__buttons {
    margin-left: auto;
  }

  &__button {
    &:nth-child(n + 2) {
      margin-left: 16px;
    }
  }
}

.buttons {
  display: flex;
  align-items: center;
  gap: 16px;
}
</style>
